import CampusTabs from "./CampusTabs";

export default CampusTabs;
